import React, { Component } from "react";
import { Responsive } from "react-admin";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Tooltip from "@material-ui/core/Tooltip";
import NotificationsOff from "@material-ui/icons/NotificationsOff";
import Notification from "@material-ui/icons/Notifications";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";

export default class NotificationButton extends Component {
    state = { showSnackBar: false, error: false, notificationMessage: "" };

    setNotification = () => {
        const { resource_id, type } = this.props;

        myRestClient("UPDATE_NO_PREV", "notification", {
            id: resource_id,
            data: { type: type }
        }).then(
            res => {
                this.setState({ showSnackBar: true });
            },
            err => {
                this.setState({ error: true });
                this.setState({ showSnackBar: true });
                this.setState({ notificationMessage: err.body.message });
                return;
            }
        );
    };

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={6000}
                message={this.renderSnackMessage()}
                onClose={_ =>
                    this.setState({ error: false, showSnackBar: false })
                }
            />
        );
    }

    renderSnackMessage() {
        const { type } = this.props;
        return this.state.error === false ? (
            <span id="snack-message">
                {type === "reset" ? (
                    <TranslatedText resource_name="resources.notification.actions.notificationResetSent" />
                ) : (
                    <TranslatedText resource_name="resources.notification.actions.notificationNewSent" />
                )}
            </span>
        ) : (
            <span id="snack-message">{this.state.notificationMessage}</span>
        );
    }

    render() {
        const { type } = this.props;
        return (
            <span>
                <Button
                    color="primary"
                    target="_blank"
                    onClick={this.setNotification}
                >
                    <Responsive
                        small={
                            <Tooltip
                                title={
                                    type === "reset" ? (
                                        <TranslatedText resource_name="resources.notification.actions.resetNotification" />
                                    ) : (
                                        <TranslatedText resource_name="resources.notification.actions.newNotification" />
                                    )
                                }
                            >
                                {type === "reset" ? (
                                    <NotificationsOff />
                                ) : (
                                    <Notification />
                                )}
                            </Tooltip>
                        }
                        medium={
                            type === "reset" ? (
                                <NotificationsOff />
                            ) : (
                                <Notification />
                            )
                        }
                    />
                    <Responsive
                        small={<span />}
                        medium={
                            <span style={{ paddingLeft: "0.5em" }}>
                                {type === "reset" ? (
                                    <TranslatedText resource_name="resources.notification.actions.resetNotification" />
                                ) : (
                                    <TranslatedText resource_name="resources.notification.actions.newNotification" />
                                )}
                            </span>
                        }
                    />
                </Button>
                {this.renderSnackBar()}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NotificationButton.js